module.exports = __webpack_public_path__ + "static/media/26UNRWA10.5a041c96.jpg";